import PropTypes from 'prop-types';
import classnames from 'classnames';

const IconButton = (props) => {
  const {
    href, className, icon: Icon, ...rest
  } = props;

  const classes = classnames('icon-button', className);

  return (
    <a className={classes} role="button" href={href} {...rest}>
      <Icon />
    </a>
  );
};

IconButton.propTypes = {
  /**
   * any other class on IconButton.
   * */
  className: PropTypes.string,
  /**
   * the destination address.
   * */
  href: PropTypes.string.isRequired,
  /**
   * declares an associated icon: this can be a React Component or an instance
   * of a React Component.
   * */
  icon: PropTypes.func.isRequired,
};

IconButton.defaultProps = {
  className: '',
};

export default IconButton;
